import { get } from 'es-toolkit/compat';
import * as React from 'react';
import { FieldProps } from 'formik';

import { Checkbox } from './Checkbox';

interface Props extends FieldProps {
  className?: string;
  label: string;
  value?: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
}

/**
 * @deprecated
 * Plase see ui folder of your project
 * Use `FormikCheckbox` to have a boolean field in a formik based form. .
 *
 * ```js
 * import { FormikCheckbox } from '.';
 * ```
 */
export class FormikCheckbox extends React.Component<Props> {
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { field, onChange } = this.props;

    field.onChange(event);

    if (onChange) {
      onChange(event);
    }
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { field, onBlur } = this.props;

    field.onBlur(event);

    if (onBlur) {
      onBlur(event);
    }
  };

  render() {
    const {
      field,
      form: { touched, errors },
      label,
      className,
      value,
      ...props
    } = this.props;

    const hasError = !!(get(touched, field.name) && get(errors, field.name));

    // checkbox group is an array
    const isValueArray = Array.isArray(field.value);
    const isChecked = isValueArray ? field.value.includes(value) : field.value;

    return (
      <Checkbox
        checked={isChecked}
        label={label}
        className={className}
        hasError={hasError}
        error={get(errors, field.name)}
        {...field}
        {...props}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        value={isValueArray ? value : field.value}
      />
    );
  }
}
